import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FeatureToggleService = /** @class */ (function () {
    function FeatureToggleService(http) {
        this.http = http;
        this.features = null;
        this.username = null;
    }
    FeatureToggleService.prototype.getFeaturesByUsername = function (username, renewFeatures) {
        var _this = this;
        if (username === this.username && this.features && !renewFeatures) {
            return of(this.features);
        }
        else {
            this.username = username;
            return this.http.get(environment.server.api.portalpas + "/FeatureToggle").pipe(tap(function (response) {
                _this.features = response;
            }), catchError(function () {
                return of([]);
            }));
        }
    };
    FeatureToggleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureToggleService_Factory() { return new FeatureToggleService(i0.ɵɵinject(i1.HttpClient)); }, token: FeatureToggleService, providedIn: "root" });
    return FeatureToggleService;
}());
export { FeatureToggleService };
